// TEMP_DUPLICATE_MERGE_PREVIEW: isolated dev-only UI fixtures. See docs/ui-design/duplicate-merge-preview.md.
export const DUPLICATE_MERGE_PREVIEW_KEY = 'TEMP_DUPLICATE_MERGE_PREVIEW';

export const isDuplicateMergePreviewEnabled = () => process.env.NODE_ENV === 'development'
  && typeof window !== 'undefined'
  && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

export const getDuplicateMergePreview = (context) => (
  isDuplicateMergePreviewEnabled() && context?.marker === DUPLICATE_MERGE_PREVIEW_KEY ? context : null
);

export default {
  inject: {
    duplicateMergePreviewContext: { from: DUPLICATE_MERGE_PREVIEW_KEY, default: null },
  },
  computed: {
    mergePreview() {
      return getDuplicateMergePreview(this.duplicateMergePreviewContext);
    },
  },
};
